import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BaseRequestOptions, HttpModule } from '@angular/http';
import { MockBackend } from '@angular/http/testing';
import { PublisherUserAuthRoutingModule } from './auth-routing.routing';
import { PublisherUserAuthComponent } from './auth.component';
import { PublisherUserLogoutComponent } from './logout/logout.component';
import { PublisherUserAuthGuard } from './_guards/auth.guard';
import { AlertService } from '../_services/alert.service';
import { PublisherUserAuthenticationService } from './_services/authentication.service';
import { PublisherUserChangePasswordComponent } from './change-password/change-password.component';
import { PublisherAdminAuthGuard } from './_guards/admin.guard';
import { PublisherForbiddenErrorComponent } from './forbidden-error/forbidden-error.component';

@NgModule({
    declarations: [
        PublisherUserAuthComponent,
        //AlertComponent,
        PublisherUserLogoutComponent,
        PublisherUserChangePasswordComponent,
        PublisherForbiddenErrorComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        HttpModule,
        PublisherUserAuthRoutingModule
    ],
    providers: [
        PublisherUserAuthGuard,
        PublisherAdminAuthGuard,
        AlertService,
        PublisherUserAuthenticationService,
        //UserService,
        // api backend simulation
        //fakeBackendProvider,
        MockBackend,
        BaseRequestOptions
    ]
    //entryComponents: [AlertComponent],
})
export class PublisherUserAuthModule { }



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/publisher-user/auth.module.ts